/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
// import * as Yup from 'yup';
import Toast from 'react-native-toast-message';
import { View, ScrollView } from 'react-native';
import { buttonFloating } from '@/assets/styles/buttonStyles';
import SociollaText from '@components/sociolla/SociollaText';
// import { SociollaSelectBox } from '@components/sociolla/form';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import TeamMember from '@components/global/TeamMember';
// import Input from '@components/form/Input';
// import MarketTypeSearch from '@components/form/search/MarketTypeSearch';
import WarehouseSearch from '@components/form/search/WarehouseSearch';
import ProgressBar from '@components/global/ProgressBar';
import * as Layout from '@components/screen/Layout';
import ItemDetail from '@components/global/ItemDetail';
import { isWeb } from '@global/screens';
import { showPopup } from '@/store/modal';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';

const SalesTeamFormScreen = (props) => {
  const dispatch = useDispatch();

  const [detailData, setDetailData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [page, setPage] = useState(1);

  // const FormValidationSchema = Yup.object().shape({
  // name: Yup.string()
  //   .matches(/^[a-z0-9 ]+$/i, {
  //     excludeEmptyString: true,
  //     message: 'Name must be alphanumeric',
  //   })
  //   .trim()
  //   .required('Name is required.'),
  // market_type: Yup.object().required('Market type is required.'),
  // warehouse: Yup.object().required('Warehouse is required.'),
  // payment_method: Yup.string().required('Payment method is required.'),
  // short_code: Yup.string().required('Short Code is required.'),
  // is_active: Yup.mixed().required().label('Status is required.'),
  // });

  const getSalesTeamDetail = useApi(MsB2b.getSalesTeamDetail);

  const getDetail = async (id) => {
    const response = await getSalesTeamDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      setDetailData(response.data.data);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setPage(1);
      setIsEdit(false);
      setDetailData({});
      if (props?.route?.params?.id) {
        setIsEdit(true);
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {!isWeb && <ProgressBar page={page} totalPage={2} />}
      {isEdit && getSalesTeamDetail && getSalesTeamDetail.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (isEdit ? detailData && Object.keys(detailData).length : true) ? (
        <Formik
          initialValues={{
            // name:
            //   isEdit && detailData && detailData.name ? detailData.name : '',
            // market_type:
            //   isEdit &&
            //   detailData &&
            //   detailData.market_type &&
            //   Object.keys(detailData.market_type).length
            //     ? detailData.market_type
            //     : '',
            // warehouse:
            //   isEdit &&
            //   detailData &&
            //   detailData.warehouse &&
            //   Object.keys(detailData.warehouse).length
            //     ? detailData.warehouse
            //     : '',
            optional_warehouse:
              isEdit &&
              detailData &&
              detailData.optional_warehouse &&
              Object.keys(detailData.optional_warehouse).length
                ? detailData.optional_warehouse
                : '',
            team_members:
              isEdit &&
              detailData &&
              detailData.team_members &&
              detailData.team_members.length
                ? detailData.team_members
                : '',
            // payment_method:
            //   isEdit && detailData && detailData.payment_method
            //     ? detailData.payment_method
            //     : '',
            // short_code:
            //   isEdit && detailData && detailData.short_code
            //     ? detailData.short_code
            //     : '',
            // is_active:
            //   isEdit && detailData && detailData.is_active
            //     ? { name: 'Active', value: true }
            //     : { name: 'InActive', value: false },
          }}
          // validationSchema={FormValidationSchema}
          onSubmit={async (payload) => {
            dispatch(showPopup({ name: 'isLoading', value: true }));
            try {
              if (payload) {
                if (!(payload.team_members && payload.team_members.length)) {
                  payload.team_members = [];
                }
                payload.optional_warehouse =
                  payload.optional_warehouse &&
                  payload.optional_warehouse.length
                    ? payload.optional_warehouse.map((item) => {
                        return {
                          id: item.id,
                          name: item.name,
                          position_height: item.position_height,
                          pacman_warehouse_id: item.pacman_warehouse_id,
                        };
                      })
                    : [];
              }

              if (isEdit) {
                const updateData = await MsB2b.updateSalesTeam(
                  detailData._id,
                  payload,
                );
                if (updateData && updateData.data && updateData.data.data) {
                  dispatch(showPopup({ name: 'isLoading', value: false }));
                  Toast.show({
                    text1: 'Successfully edited data',
                    type: 'success',
                  });
                  props.navigation.navigate('SalesTeamDetailScreen', {
                    titleScreen: detailData.name,
                    name: detailData.name,
                    id: detailData._id,
                    short_code: detailData.short_code,
                  });
                } else {
                  dispatch(showPopup({ name: 'isLoading', value: false }));
                  Toast.show({
                    text1: 'A system error occurred',
                    type: 'error',
                  });
                }
              }
            } catch (error) {
              console.log(error);
              dispatch(showPopup({ name: 'isLoading', value: false }));
              Toast.show({
                text1:
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  'A system error occurred',
                type: 'error',
              });
            }
          }}>
          {({
            setFieldValue,
            validateForm,
            handleSubmit,
            errors,
            touched,
            values,
          }) => (
            <>
              {isWeb ? (
                <Layout.Wrapper white={false}>
                  <Layout.Back
                    title="Sales Team"
                    onCallback={() =>
                      isEdit
                        ? props.navigation.navigate(
                            'SalesTeamDetailScreen',
                            props.route.params,
                          )
                        : props.navigation.navigate('SalesTeamScreen')
                    }
                  />
                  <Layout.Title
                    title={isEdit ? 'Edit Sales Team' : 'Add Sales Team'}>
                    <Button
                      rounded={true}
                      buttonStyle={{ width: 120 }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{
                            fontSize: 14,
                            letterSpacing: 0.5,
                            color: Colors.white,
                          }}>
                          {isEdit ? 'UPDATE' : 'SAVE'}
                        </SociollaText>
                      }
                      onPress={handleSubmit}
                    />
                  </Layout.Title>
                </Layout.Wrapper>
              ) : (
                false
              )}
              <Layout.Wrapper rounded hasProgressBar={true} isHeight>
                <ScrollView>
                  {isWeb || page == 1 ? (
                    <Layout.FormWrapper
                      style={{
                        width: isWeb ? 400 : '100%',
                        paddingHorizontal: 15,
                        ...(isWeb
                          ? {
                              paddingHorizontal: 20,
                              paddingTop: 20,
                              marginBottom: 15,
                            }
                          : {}),
                      }}>
                      <ItemDetail
                        name="Name"
                        value={detailData?.name ? detailData?.name : '-'}
                      />
                      <ItemDetail
                        name="Market Type"
                        value={
                          detailData?.market_type &&
                          detailData?.market_type?.code
                            ? detailData?.market_type?.code
                            : '-'
                        }
                      />
                      <ItemDetail
                        name="Warehouse"
                        value={
                          detailData?.warehouse && detailData?.warehouse?.name
                            ? detailData?.warehouse?.name
                            : '-'
                        }
                      />
                      <Layout.FormGroup>
                        <WarehouseSearch
                          label="Optional Warehouse"
                          isWarehouse={true}
                          value={values.optional_warehouse}
                          multiple={true}
                          hasError={
                            errors.optional_warehouse &&
                            touched.optional_warehouse
                              ? errors.optional_warehouse
                              : null
                          }
                          isRequired={false}
                          onChange={(value) =>
                            setFieldValue('optional_warehouse', value)
                          }
                        />
                      </Layout.FormGroup>
                      <ItemDetail
                        name="Payment Method"
                        value={
                          detailData?.payment_method
                            ? detailData?.payment_method
                            : '-'
                        }
                      />
                      <ItemDetail
                        name="Short Code"
                        value={
                          detailData?.short_code ? detailData?.short_code : '-'
                        }
                      />
                      <ItemDetail
                        name="Is Active"
                        value={detailData?.is_active ? 'Active' : 'Inactive'}
                      />
                    </Layout.FormWrapper>
                  ) : (
                    false
                  )}
                  {isEdit && (isWeb ? true : page == 2) ? (
                    <TeamMember
                      data={
                        values.team_members && values.team_members.length
                          ? values.team_members.map((item) => {
                              item.sales_team = detailData.name;
                              return item;
                            })
                          : []
                      }
                    />
                  ) : (
                    false
                  )}
                </ScrollView>
              </Layout.Wrapper>
              {!isWeb ? (
                <View style={buttonFloating}>
                  {page == 1 ? (
                    <Button
                      rounded={true}
                      buttonStyle={{ width: '100%' }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{
                            fontSize: 14,
                            letterSpacing: 0.5,
                            color: Colors.white,
                          }}>
                          {isEdit ? 'NEXT' : 'SAVE'}
                        </SociollaText>
                      }
                      onPress={!isEdit ? handleSubmit : () => setPage(2)}
                    />
                  ) : (
                    <View
                      style={{
                        width: '100%',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}>
                      <View style={{ width: '48%' }}>
                        <Button
                          type="outline-primary"
                          rounded={true}
                          buttonStyle={{ width: '100%' }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.blue1,
                              }}>
                              PREV
                            </SociollaText>
                          }
                          onPress={() => setPage(1)}
                        />
                      </View>
                      <View style={{ width: '48%' }}>
                        <Button
                          rounded={true}
                          buttonStyle={{ width: '100%' }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              {isEdit ? 'UPDATE' : 'SAVE'}
                            </SociollaText>
                          }
                          onPress={(evt) => {
                            evt.persist();
                            setTimeout(() => {
                              validateForm().then((validate) => {
                                handleSubmit(evt);
                                if (validate && Object.keys(validate).length) {
                                  setPage(1);
                                }
                              });
                            }, 100);
                          }}
                        />
                      </View>
                    </View>
                  )}
                </View>
              ) : (
                false
              )}
            </>
          )}
        </Formik>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

export default SalesTeamFormScreen;
